// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import styled from 'styled-components';

export const Button = styled.div`
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 999;
  cursor: pointer;
`;

export const ScrollToTopIcon = styled.img`
  width: 95px;
  height: 95px;
`;
